import { Component, OnInit, Inject } from '@angular/core';
import { IDripApplicationRate } from '../interfaces';
import { CalculateService } from '../../../services/calculate.service';
import { DripApplicationRateFields } from '../calculatorSettingsForm';
import { FormValidation } from '../../../classes/formValidation';
import { Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedUpdateService } from '../../shared/dialogs/update.service';

@Component({
	moduleId: module.id,
	selector: 'drip-application-rate',
	templateUrl: 'drip-application-rate.html',
	styleUrls: ['drip-application-rate.scss']
})

export class DripApplicationRateComponent implements OnInit {

	public form: FormGroup;

	public get f(): { [key in DripApplicationRateFields]: AbstractControl } {
		return this.form.controls as { [key in DripApplicationRateFields]: AbstractControl };
	}

	private _control: AbstractControl;
	private _initialValues: IDripApplicationRate;

	constructor(
		@Inject(MAT_DIALOG_DATA) private _data: {
			form: FormGroup, control: AbstractControl },

		private _dialogRef: MatDialogRef<DripApplicationRateComponent>,
		private calculateService: CalculateService,
		private _sharedUpdateService: SharedUpdateService,
	) {
	}

	ngOnInit(): void {
		this.form = this._data.form;
		this._control = this._data.control;
		this._initialValues = this.form.value; // save initial values
		this._setValidators();
	}

	public calculate(e: MouseEvent): void {
		let result: number;

		result = this.calculateService.calculateDripApplicationRate(this.f.BedWidth.value,
			this.f.DripLinesPerBed.value, this.f.TapeDischargeRate.value);

		result = Number(result.toFixed(2));
		this._control.setValue(result);

		this._clearValidators();
		this._closeDialog();
	}

	public cancel(e: MouseEvent): void {
		this.form.reset(this._initialValues);
		this._clearValidators();
		this._closeDialog();
	}

	private _setValidators(): void {
		FormValidation.setValidator(this.f.BedWidth, [Validators.required, FormValidation.integerValidator()]);
		FormValidation.setValidator(this.f.DripLinesPerBed, [Validators.required, FormValidation.integerValidator()]);
		FormValidation.setValidator(this.f.TapeDischargeRate, [Validators.required]);
	}

	private _clearValidators(): void {
		FormValidation.clearValidator(this.f.BedWidth);
		FormValidation.clearValidator(this.f.DripLinesPerBed);
		FormValidation.clearValidator(this.f.TapeDischargeRate);
	}

	private _closeDialog() {
		this._sharedUpdateService.cancel();
		this._dialogRef.close();
	}
}
